import { Component, computed, Signal, signal, WritableSignal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IconComponent } from "@kinomap-dev/ng-ui-lib/basics";
import { createNotification, Notification } from '../../types/notification.type';


import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-notification-dropdown',
  imports: [TranslateModule, IconComponent, DatePipe],
  templateUrl: './notification-dropdown.html',
  styleUrl: './notification-dropdown.scss',
})
export class NotificationDropdown {
  _notifications: WritableSignal<Notification[]> = signal([
    createNotification({ date: new Date('2026-07-30T09:20:00'), isRead: false, type: 'WAITING_INTERVAL_EDIT', contentTitle: "VÉLO BRÛLE GRAISSE : 1'/1' - NIVEAU 1" }),
    createNotification({ date: new Date('2026-07-29T19:34:00'), isRead: false, type: 'AVAILABLE_CONTENT', contentTitle: 'BRUTAL CLIMB AFTER 8 MIN WARMUP' }),
    createNotification({ date: new Date('2026-07-16T11:01:00'), isRead: true, type: 'WAITING_INTERVAL_EDIT', contentTitle: 'SUNNY 🌞 WINTER❄️🚵 RIDE 2026 HATTING' }),
    createNotification({ date: new Date('2026-07-12T17:28:00'), isRead: true, type: 'CONTENT_CONVERT', contentTitle: 'NICE PROMENADE DES ANGLAIS' }),
    createNotification({ date: new Date('2026-07-03T23:42:00'), isRead: true, type: 'AVAILABLE_CONTENT', contentTitle: 'SNOWY COLORADO RIVER' }),
    createNotification({ date: new Date('2026-06-13T18:35:00'), isRead: true, type: 'CONTENT_REFUSED', contentTitle: 'OH CHAMPS ELYSÉE' }),
    createNotification({ date: new Date('2026-06-11T07:48:00'), isRead: true, type: 'KINO_MESSAGE', title: 'Titre lorem ipsum communication kinomap', tip: 'Texte lorem ipsum de lorem ipsum it dolor sit amet it dolor pour expliquer la nouveauté de Kinomap.' }),
    createNotification({ date: new Date('2026-06-11T07:48:00'), isRead: true, type: 'NEW_COMMENT', contentTitle: "COL D'IZOARD FROM LE LAUS" }),
    createNotification({ date: new Date('2026-06-11T07:48:00'), isRead: true, type: 'PLANIFICATION_PUBLISH', contentTitle: 'SUNSET ITALIEN' }),
    createNotification({ date: new Date('2026-06-11T07:48:00'), isRead: true, type: 'PLANIFICATION_DATE_CHANGE', contentTitle: 'SUNSET ITALIEN' }),
  ]);
  unreadNotification: Signal<Notification[]> = computed(() => this._notifications().filter((notif: Notification) => !notif.isRead))

  state: WritableSignal<'all' | 'unread'> = signal('all');

  notifications: Signal<Notification[]> = computed(() => {
    if (this.state() === "all") {
      return this._notifications()
    }
    return this.unreadNotification()
  })

}
